angular
    .module('MW.v11n.MapHighChart', [
        'CoreColorService'
    ])
    .directive('mapHighchart', [
        'CoreColorService',
        '$routeParams',
        function(CoreColorService, $routeParams) {
        'use strict';

        return {
            template: '<div class="v11nWorldMap"></div>',
            restrict: 'E',
            replace: true,
            scope: {
                chartData: '=data',
                drill: '&drill',
                drillmap: '&drillmap',
                isMaximized: '=maximized',
                isReport: '=?',
                exportType: '=?'
            },
            link: function(scope, element, attrs) {
                // This sets the thousands separator to , - we probably should moved it to somewhere more general to be used everywhere
                Highcharts.setOptions({
                    lang: {
                        thousandsSep: ','
                    }
                });
                scope.selectedDrilledCountry = null;

                scope.getParentWidth = function getParentWidth(element) {
                    return element[0].parentNode.clientWidth;
                };

                scope.getParentHeight = function getParentHeight(element) {
                    return element[0].parentNode.clientHeight;
                };

                var fitToParent = function() {
                    scope.chartData.width = scope.getParentWidth(element);
                    scope.chartData.height = scope.getParentHeight(element);
                }

                scope.$on('widgetResized', function() {
                    fitToParent();
                    draw();
                });

                scope.$watch(function() { return scope.chartData; }, function(data) {
                    if (!data) return;
                    fitToParent();
                    draw();
                });

                var draw = function() {
                    var mapSwitch = 0,
                        selected = null,
                        settings = {
                        exporting: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        subtitle: {
                            text: null
                        },
                        legend: {
                            layout: 'vertical',
                            align: 'right',
                            verticalAlign: 'bottom',
                            padding: 10
                        },
                        credits: {
                            enabled: false
                        },
                        chart: {
                            border: 0,
                            marginTop: 0,
                            events: {
                            }
                        },
                        loading: {
                            style: {
                                opacity: 1.0
                            }
                        },
                        tooltip: {
                            headerFormat: '',
                            pointFormat: '{point.name}: <b>{point.value} ({point.percentage:.2f}%)</b><br/>'
                        },
                        mapNavigation: {
                            enableMouseWheelZoom: false,
                            buttonOptions: {
                            theme: {
                                fill: '#F7F7F7',
                                'stroke-width': 0,
                                stroke: 'silver',
                                r: 1,
                                states: {
                                    hover: {
                                       fill: '#ccc',
                                       stroke: '#ddd'
                                    }
                                }
                            },
                            verticalAlign: 'bottom',
                            }
                        },

                        colorAxis: {
                            min: 0,
                            reversed: false
                        },
                        plotOptions: {
                            map: {
                                states: {
                                    hover: {
                                        color: CoreColorService.colors.greyOrange
                                    },
                                    select: {
                                        color: CoreColorService.colors.greyOrange
                                    }
                                },
                                borderWidth: 0,
                                dataLabels: {
                                    style: {
                                        'color': '#555',
                                        'fontWeight': 'normal',
                                        'HcTextStroke': '2px rgba(0,0,0,0.9)'
                                    },
                                    formatter: function() {
                                        // For detailed maps hc-key is the combincation of the countrycode-regioncode, we need to show the name
                                        var pointName = this.point['hc-key'];
                                        if(pointName.indexOf('-') != -1)
                                            return this.point.name + ' (' + this.point.value + ')';
                                        else
                                            return pointName.toUpperCase() + ' (' + Highcharts.numberFormat(this.point.value, 0, 0, ',') + ')';
                                    }
                                },
                            },
                            series: {
                                point: {
                                    events: {
                                    }
                                }
                            }
                        },
                        series: [{
                            allowPointSelect: true,
                            color: CoreColorService.colors.yellowDark,
                        }],
                        drilldown: {
                            animation: false,
                            activeDataLabelStyle: {
                                'color': '#555',
                                'fontWeight': 'normal',
                                'HcTextStroke': '2px rgba(0,0,0,0.9)',
                                'textDecoration': 'none'
                            },
                            drillUpButton: {
                                relativeTo: 'spacingBox',
                                position: {
                                    x: 0,
                                    y: -1000
                                }
                            }
                        }
                    };

                    if($routeParams.country)
                        scope.selectedDrilledCountry = $routeParams.country;
                    if($routeParams.continent)
                    scope.selectedDrilledContinent = $routeParams.continent;

                    var map = scope.chartData.geoSource;
                    var data = Highcharts.geojson(Highcharts.maps[map]);
                    var backendResponseEntries = [];
                    var backendResponseDict = {};
                    var country = map.substring(map.indexOf("/") + 1, map.lastIndexOf("/"));

                    var dt = scope.chartData.data;
                    var totalVolume = 1;

                    for (var i = 0; i < scope.chartData.data.length; i++) {
                        if(scope.chartData.data[i].value > totalVolume)
                            totalVolume = scope.chartData.data[i].value;
                        var hcKey = scope.chartData.data[i]['hc-key']
                        if (map.indexOf('countries/') !== -1) {
                            //detailed country maps
                            if (country === 'us') {
                                backendResponseEntries.push(hcKey);
                                backendResponseDict[hcKey] = scope.chartData.data[i];
                             } else {
                                 //detailed country maps
                                 // scope.chartData.data[i]['hc-key'] = hcKey.substring(0, hcKey.lastIndexOf(" "));
                                 scope.chartData.data[i]['hc-key'] = hcKey;
                                 backendResponseEntries.push(hcKey.substring(0, hcKey.lastIndexOf(" ")));
                                 backendResponseDict[hcKey.substring(0, hcKey.lastIndexOf(" "))] = scope.chartData.data[i];
                             }
                            // backendResponseEntries.push(scope.chartData.data[i]['hc-key']);
                            // backendResponseDict[scope.chartData.data[i]['hc-key']] = scope.chartData.data[i];
                        } else {
                            backendResponseEntries.push(scope.chartData.data[i]['hc-key']);
                            backendResponseDict[scope.chartData.data[i]['hc-key']] = scope.chartData.data[i];
                        }
                    }
                    var hc = null;
                    $.each(data, function (i) {
                        hc = data[i]['properties']['hc-key'];
                        data[i].key = hc;
                        data[i].percentage = 0;
                        if(backendResponseEntries.indexOf(hc) > -1) {
                            data[i].percentage = backendResponseDict[hc].percentage;
                            data[i].value = backendResponseDict[hc].value;
                            if(backendResponseDict[hc].type)
                                data[i].type = backendResponseDict[hc].type;
                            if(backendResponseDict[hc].drilldown) // Adding any drilldown (for now its U.S only)
                                data[i].drilldown = backendResponseDict[hc].drilldown;
                        } else
                            data[i].value = 0;
                    });

                    //Detailed country maps
                    if (map.indexOf('countries/') !== -1) {
                        var level1 = Object.keys(backendResponseDict);
                        $.each(data, function(i) {
                            if (level1.indexOf(this.name) > -1) {
                                this.value = backendResponseDict[this.name].value;
                                this.percentage = backendResponseDict[this.name].percentage;
                            } else
                                this.value = 0;
                        });
                    }

                    settings.chart.renderTo = element[0];

                    // settings.legend.enabled = scope.chartData.legend;
                    if(!scope.chartData.legend) {
                        settings.legend.layout = "horizontal";
                        settings.legend.y = 300;
                    }
                    settings.chart.height =  (scope.isMaximized) ? 400 :scope.chartData.height;
                    if(!scope.isMaximized)
                        settings.chart.width = scope.chartData.width;
                    else if(scope.isReport && typeof scope.isReport !== 'function') {
                        settings.chart.width = 700;
                        if(scope.exportType === 'widgetImage') {
                            settings.chart.width = 1150;
                        }
                    }
                    else { // Maximized view
                        if(scope.chartData.legend) {
                            settings.chart.width = element[0].parentNode.clientWidth - 40; //40 pixel less so that legend labels get visible
                        } else {
                            settings.chart.width = element[0].parentNode.clientWidth;
                        }

                    }
                    settings.plotOptions.map.dataLabels.enabled = scope.chartData.dataLabels;
                    settings.series[0].data = data;
                    settings.series[0].mapData = data;

                    settings.series[0].joinBy = ['hc-key', 'key'];
                    settings.series[0].name = scope.chartData.name;

                    settings.colorAxis.max = totalVolume;
                    if(scope.chartData.data.length === 1 && scope.chartData.data[0]['hc-key'] === 'zz') {
                        settings.colorAxis.minColor = '#FFECBE';
                        settings.colorAxis.maxColor = '#FFECBE';
                    } else {
                        settings.colorAxis.stops = scope.chartData.color;
                    }

                    settings.plotOptions.series.point.events.click = function(e) {
                        if(!scope.isMaximized)
                            return;

                        if(mapSwitch == 0 || selected!= e.point['hc-key']) {
                            e.point.zoomTo();
                            selected = e.point['hc-key'];
                            mapSwitch = 1;
                        } else {
                            chart.mapZoom();
                            mapSwitch = 0;
                        }

                        var id = null;
                        this.selected = false; //This is to trick highchart that the point is not selected (GYDA-9810)
                        if(this.type === 'continent') {
                            id = this['hc-key'];
                            scope.drill({id: id, type: 'continent'})
                        }
                        else if(this.type === 'country'  || (scope.selectedDrilledContinent && !scope.selectedDrilledCountry)) {
                            id = this.properties['hc-key'] || this['hc-key'];
                        scope.drill({
                            id: id,
                            type: 'country',
                            parentCountry: $routeParams.continent
                        })
                        }
                        else if ((scope.selectedDrilledCountry && scope.selectedDrilledContinent) && this.type === 'region' || !this.type){
                            id = this['name'];
                            scope.drill({
                                id: id,
                                type: 'region',
                                parentCountry: scope.selectedDrilledCountry,
                                parentContinent: scope.selectedDrilledContinent
                            });
                        }
                    }

                    settings.chart.events.drillup =  function () {
                        scope.drill('all');
                    }

                    settings.mapNavigation.enabled = (scope.isMaximized) ? true: false;

                    settings.chart.events.drilldown = function (e) {
                        if (scope.isMaximized) {
                            if (!e.seriesOptions) {
                                if ($routeParams.region) {
                                    scope.selectedDrilledCountry = $routeParams.country;
                                    if($routeParams.continent) {
                                        scope.selectedDrilledContinent = $routeParams.continent;
                                    }
                                    scope.drill({id: $routeParams.region, type: 'region', parentCountry:$routeParams.country});
                                } else if (e.point.type === 'continent') {
                                    scope.selectedDrilledContinent = $routeParams.continent || 'continent';
                                    scope.drill({id: e.point.drilldown, type: 'continent'});

                                } else {
                                    scope.selectedDrilledCountry = e.point.drilldown;
                                    if($routeParams.continent)
                                        scope.selectedDrilledContinent = $routeParams.continent;
                                    scope.drill({id: e.point.drilldown, type: 'country'});

                                }
                                var chart = this,
                                    mapKey;

                                // detecting what?
                                switch(e.point.type) {

                                    case 'continent':
                                        // This could be a dictionary to fetch corresponding mapKey
                                        if(e.point.drilldown == 'as') {
                                            mapKey = 'custom/asia';
                                        } else if(e.point.drilldown == 'na') {
                                            mapKey = 'custom/north-america';
                                        } else if(e.point.drilldown == 'af') {
                                            mapKey = 'custom/africa';
                                        } else if(e.point.drilldown == 'sa') {
                                            mapKey = 'custom/south-america';
                                        } else if(e.point.drilldown == 'eu') {
                                            mapKey = 'custom/europe';
                                        } else if(e.point.drilldown == 'oc') {
                                            mapKey = 'custom/oceania';
                                        }
                                    break;
                                    case 'country':
                                        mapKey = 'countries/' + e.point.drilldown + '/' + e.point.drilldown + '-all';

                                    break;
                                };

                                // detecting what end?

                                // Handle error, the timeout is cleared on success
                                    var fail = setTimeout(function () {
                                        if (!Highcharts.maps[mapKey]) {
                                            chart.showLoading('<i class="icon-frown"></i> Failed loading ' + e.point.name);

                                            fail = setTimeout(function () {
                                                chart.hideLoading();
                                            }, 1000);
                                        }
                                    }, 3000);

                                // Show the spinner
                                chart.showLoading('<i class="spinner"></i>');
                                var data = null;
                                // Load the drilldown map
                                data = Highcharts.geojson(Highcharts.maps[mapKey]);
                                var type = (e.point.type == 'continent') ? 'country' : 'region';
                                scope.drillmap({
                                    id: e.point.drilldown, type: type, callback: function (mapData) {
                                        var regionDict = {};
                                        var level1 = Object.keys(regionDict);
                                        var externalDataMap = {};

                                        $.each(data, function (i) {
                                            switch(type) {
                                                case 'country':
                                                    if (level1.indexOf(this.properties['hc-key']) > -1)  {
                                                        this.value = regionDict[this.properties['hc-key']].value;
                                                        if(['us', 'ar', 'br', 'au'].indexOf(this.properties['hc-key']) > -1) {
                                                            this.drilldown = this.properties['hc-key'];
                                                            this.type = 'country';
                                                            this.name = this.properties['hc-key'].toUpperCase();
                                                        } else {
                                                            this.type = 'country';
                                                            this.name = this.properties['hc-key'].toUpperCase();
                                                        }
                                                        // this.percentage = regionDict[this.properties.name].percentage;
                                                    }
                                                    else {
                                                        this.value = 0;
                                                    }
                                                break;
                                                case 'region':
                                                    if (level1.indexOf(this.name) > -1)  {
                                                        this.value = regionDict[this.name].value;
                                                        this.percentage = regionDict[this.name].percentage;
                                                    }
                                                    else {
                                                        this.value = 0;
                                                    }
                                                break;
                                            }

                                        });
                                        // Hide loading and add series
                                        chart.hideLoading();
                                        clearTimeout(fail);
                                        chart.addSeriesAsDrilldown(e.point, {
                                            name: e.point.name,
                                            data: data,
                                            allowPointSelect: true,
                                            dataLabels: {
                                                enabled: scope.chartData.dataLabels,
                                                formatter: function() {
                                                    return this.point.name + ' (' + this.point.value + ')';
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                            this.setTitle(null, {
                                text: null
                            });
                        }
                    };
                    var chart = new Highcharts.Map(settings);

                }
            }

        }
}]);

$('.highcharts-xaxis-labels text').hover(function(e) {
    chart.tooltip.refresh(chart.series[0].data[$(this).index()]);
    chart.series[0].data[$(this).index()].setState('hover');
});